var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRedPencilIcon = function SvgRedPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2458",
    d: "M11.427 1.074a1.813 1.813 0 0 0-2.562 0L.733 9.206A2.484 2.484 0 0 0 0 10.974V12a.5.5 0 0 0 .5.5h1.027a2.483 2.483 0 0 0 1.767-.732l8.133-8.133a1.813 1.813 0 0 0 0-2.561Zm-8.84 9.987c-.282.28-.663.438-1.06.439H1v-.527a1.49 1.49 0 0 1 .44-1.06L7.61 3.741l1.15 1.15-6.174 6.17Zm8.132-8.133L9.466 4.182l-1.15-1.148L9.57 1.781a.812.812 0 1 1 1.147 1.15l.002-.003Z"
  })));
};
export default SvgRedPencilIcon;